<div id="login-modal" class="modal" tabindex="-1" role="dialog" 
     [class.show]="authService.isLoginModalOpen()" 
     [style.display]="authService.isLoginModalOpen() ? 'block' : 'none'" 
     [style.background]="'rgba(0,0,0,0.5)'">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center">
          <span class="material-symbols-outlined me-2 fs-4">account_circle</span>
          Account Login
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        
        <!-- Instructions / Notification -->
        @if (step() === 'email') {
          <p class="description-text">
            Enter your email address to receive a verification code and access your account history.
          </p>
        } @else {
          <div class="alert alert-success d-flex align-items-center mb-3 py-2 px-3" role="alert">
            <span class="material-symbols-outlined me-2 fs-5 text-success">check_circle</span>
            <div>
              {{ successMessage() || 'We have sent a verification code to your email.' }}
            </div>
          </div>
        }

        <!-- Alerts -->
        @if (errorMessage()) {
          <div class="alert alert-danger d-flex align-items-center mb-3 py-2 px-3" role="alert">
            <span class="material-symbols-outlined me-2 fs-5 text-danger">error</span>
            <div>{{ errorMessage() }}</div>
          </div>
        }

        <!-- Step 1: Email Input -->
        <div class="form-group mb-3">
          <label for="login-email">Email Address</label>
          <div class="input-group">
            <span class="input-group-text bg-white">
              <span class="material-symbols-outlined text-muted fs-5">mail</span>
            </span>
            <input 
              id="login-email"
              type="email" 
              class="form-control" 
              placeholder="Enter your email (e.g. user@example.com)" 
              [ngModel]="email()" 
              (ngModelChange)="email.set($event)"
              [disabled]="step() === 'otp' || isLoading()"
              (keydown.enter)="step() === 'email' ? onSendCode() : null"
              required>
            
            @if (step() === 'otp') {
              <button 
                type="button" 
                class="btn btn-outline-secondary change-btn d-flex align-items-center" 
                (click)="onChangeEmail()"
                [disabled]="isLoading()">
                <span class="material-symbols-outlined me-1 fs-6">edit</span>Change
              </button>
            }
          </div>
        </div>

        <!-- Step 2: OTP Verification Code Input -->
        @if (step() === 'otp') {
          <div class="form-group mb-3 otp-group">
            <label for="login-otp">Verification Code (OTP)</label>
            <div class="input-group">
              <span class="input-group-text bg-white">
                <span class="material-symbols-outlined text-muted fs-5">shield</span>
              </span>
              <input 
                id="login-otp"
                type="text" 
                class="form-control otp-input" 
                placeholder="Enter 6-digit or verification code" 
                [ngModel]="otp()" 
                (ngModelChange)="otp.set($event)"
                [disabled]="isLoading()"
                (keydown.enter)="onVerifyCode()"
                autocomplete="one-time-code"
                autofocus
                required>
            </div>
            <small class="text-muted mt-1 d-block">
              Didn't receive the code? 
              <a href="javascript:void(0)" class="resend-link" (click)="onSendCode()" [class.disabled]="isLoading()">
                Resend code
              </a>
            </small>
          </div>
        }

      </div>

      <!-- Footer Buttons -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isLoading()">
          Cancel
        </button>

        @if (step() === 'email') {
          <button 
            type="button" 
            class="btn btn-primary" 
            (click)="onSendCode()" 
            [disabled]="isLoading() || !email().trim()">
            @if (isLoading()) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Sending Code...
            } @else {
              <span>Send Verification Code</span>
              <span class="material-symbols-outlined ms-2 fs-5 align-middle">arrow_forward</span>
            }
          </button>
        } @else {
          <button 
            type="button" 
            class="btn btn-primary" 
            (click)="onVerifyCode()" 
            [disabled]="isLoading() || !otp().trim()">
            @if (isLoading()) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Verifying...
            } @else {
              <span>Submit & Login</span>
              <span class="material-symbols-outlined ms-2 fs-5 align-middle">check</span>
            }
          </button>
        }
      </div>

    </div>
  </div>
</div>
